import React from 'react';
import { Alert, AlertTitle } from '@mui/material';
import { CONTROLLED_DEMO_BANNER_TEXT } from '../../domain/externalReview/externalReviewCopy';

type Props = {
  /** When omitted, uses the canonical Epic 160 controlled-demo copy. */
  text?: string;
};

export default function ControlledDemoBanner({ text = CONTROLLED_DEMO_BANNER_TEXT }: Props) {
  return (
    <Alert severity="warning" variant="outlined" data-testid="controlled-demo-banner">
      <AlertTitle>Controlled demo footage</AlertTitle>
      {text.replace(/^Controlled demo footage\.\s*/i, '')}
    </Alert>
  );
}
